import "./CustomButton.css";

export function CustomButton({
  children,
  onClick,
  disabled = false,
  className = "",
}) {
  return (
    <button onClick={onClick} disabled={disabled} className={`${className}`}>
      {children}
    </button>
  );
}
